<template>
  <div class="main">
    <van-nav-bar title="个人中心" />
  </div>
</template>
<script>
export default {
  data() {
    return {};
  },
  methods: {},

  mounted() { },

  created() { },
};
</script>

<style lang="less" scoped>

</style>
